import React from "react";
import { Dropdown } from "react-bootstrap";
import cx from "classnames";

import styles from "./styles.module.scss";

import { localizedStrings } from "src/localization/index.jsx";

class OpportunityFieldDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: props.fields,
      selected: props.selected,
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.disableDropdown = this.disableDropdown.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons
  }

  handleSelect(item) {
    if(this.props.addNewCustomField){
      this.props.addNewCustomField(item);
    }
  }

  onRemoveField(item) {
    this.props.onRemove(item);
  }

  disableDropdown() {
    return this.state.selected ? true : false;
  }

  render() {
    return (
      <div className={styles.fieldDropdown}>
        <div className={styles.field}>
          <Dropdown
            key={this.state.selected ? this.state.selected.name : ""}
          >
            <Dropdown.Toggle disabled={this.disableDropdown()} className={styles.dropdown}>
              <span className={styles.text}>
                {this.state.selected
                  ? this.state.selected.label
                  : this.localizedIntegrations.select_field}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.dropdownMenu}>
              <div className={styles.options}>
                {this.state.fields &&
                  this.state.fields.map((item) => {
                    return (
                      <Dropdown.Item
                        key={item.name}
                        eventKey={item}
                        onClick={() => this.handleSelect(item)}
                        className={styles.item}
                      >
                        {item.label}
                      </Dropdown.Item>
                    );
                  })}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className={styles.listValues}>
          {this.state.selected && (
            <Dropdown rootCloseEvent="click">
              <Dropdown.Toggle className={styles.dropdown}>
                <span className={styles.text}> { this.localizedIntegrations.view_list_values } </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.dropdownMenu}>
                <div className={styles.options}>
                  {this.state.selected.values &&
                    this.state.selected.values.map((item, index) => {
                      return (
                        <Dropdown.Item key={item.label} className={styles.item}>
                          {item.label}
                        </Dropdown.Item>
                      );
                    })}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>

        <div
          className={styles.remove}
          onClick={() => this.onRemoveField(this.state.selected)}
        >
          <span className={styles.text}> { this.localizedCommons.actions.remove } </span>
        </div>
      </div>
    );
  }
}

export default OpportunityFieldDropdown;
